import { render, staticRenderFns } from "./ModalNovo.vue?vue&type=template&id=12f5eea7"
import script from "./ModalNovo.vue?vue&type=script&lang=js"
export * from "./ModalNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports